import { Autocomplete, TextField } from "@mui/material";
import { matchSorter } from "match-sorter";

const LIMIT = 30;

const AutocompleteWithRender = ({ options = [], value = null, onChange, placeholder = "Selecionar", sx = {},
    getOptionLabel = (option) => option?.label ?? "", isOptionEqualToValue = (opt, val) => opt?.value === val?.value, ...props
}) => {
    return (
        <Autocomplete
            disablePortal
            options={options}
            value={value}
            getOptionLabel={getOptionLabel}
            isOptionEqualToValue={isOptionEqualToValue}
            sx={sx}
            filterOptions={(opts, { inputValue }) => {
                const filtered = matchSorter(opts, inputValue, {
                    keys: ["label"],
                });

                return filtered.slice(0, LIMIT); 
            }}
            onChange={(e, val) => onChange?.(val ?? null)}
            renderInput={(params) => (
                <TextField {...params} multiline placeholder="Selecionar"/>
            )}
            {...props}
        />
    );
};

export default AutocompleteWithRender;